import buildComms from '@app/application/communication/sections/communication/store/comms'
import { createStore } from 'vuex'
import users from '@app/application/communication/sections/communication/store/users'
import contexts from '@app/application/communication/sections/communication/store/contexts'
import checks from '@app/application/communication/sections/communication/store/checks'
import attachments from '@app/application/communication/sections/communication/store/attachments'
import comments from '@app/application/communication/sections/communication/store/comments'
import ui from '@app/application/communication/sections/communication/store/ui'
import remarks from '@app/application/communication/sections/communication/store/remarks'
import remarkTags from '@app/application/communication/sections/communication/store/remark-tags'
import sections from '@app/application/communication/screens/inbox/store/sections'
import * as mutationTypes from '@app/application/communication/screens/inbox/store/mutation-types'
import api from '@app/application/client_meetings/screens/preparation/api'

export default function createMeetingPreparationStore(endpointParams) {
  const { state, getters, mutations, actions } = buildComms(
    endpointParams,
    {},
    api
  )

  return createStore({
    modules: {
      users,
      contexts,
      checks,
      attachments,
      comments: comments,
      ui,
      remarks,
      remarkTags,
      sections,
    },
    state() {
      return {
        ...state(),
        loading: {
          companies: false,
          mentionUsernames: false,
          communicationItem: false,
        },
        initialData: {
          ledgerId: null,
          ledgerLabel: null,
        },
      }
    },
    getters: {
      ...getters,
      loadingCompanies: ({ loading }) => loading.companies,
    },
    mutations: {
      ...mutations,
      [mutationTypes.SET_LOADING](state, { type, value }) {
        state.loading[type] = value
      },
      setInitialData(state, payload) {
        state.initialData.ledgerId = payload.ledgerId
        state.initialData.ledgerLabel = payload.ledgerLabel
      },
    },
    actions,
  })
}
